/**
 * Turns the "Color" filter's plain checkboxes into round color swatches,
 * matching the original design. Shopify's native swatch filters need each
 * option value linked to a taxonomy metafield — our catalog doesn't have
 * that set up, so this maps the real color names we sell to hex values and
 * paints a dot next to each label instead.
 */
const COLOR_HEX = {
  azul: '#3B6FA5',
  fucsia: '#D6236A',
  rosa: '#E7A6C5',
  verde: '#3F7A44',
  'verde manzana': '#8DC63F',
  amarillo: '#F2C230',
  blanco: '#FFFFFF',
  negro: '#1A1A1A',
  beige: '#D9C7A8',
  gris: '#9B9B93',
  morado: '#7A5C9E',
  naranja: '#E8792E',
};

function hexFor(label) {
  const key = label.trim().toLowerCase();
  return COLOR_HEX[key] || null;
}

function applySwatches(root = document) {
  root.querySelectorAll('.facets__panel').forEach((panel) => {
    const heading = panel.querySelector('.facets__label');
    if (!heading || heading.textContent.trim().toLowerCase() !== 'color') return;

    panel.classList.add('facets__panel--color-swatches');

    panel.querySelectorAll('.checkbox__input[data-label]').forEach((input) => {
      const label = panel.querySelector(`label[for="${input.id}"]`);
      const labelText = label?.querySelector('.checkbox__label-text');
      if (!label || !labelText || labelText.dataset.swatchApplied) return;

      const hex = hexFor(input.dataset.label);
      if (!hex) return;

      const dot = document.createElement('span');
      dot.className = 'color-swatch-dot';
      dot.style.backgroundColor = hex;
      dot.setAttribute('aria-hidden', 'true');
      labelText.before(dot);
      labelText.dataset.swatchApplied = 'true';
      label.classList.add('checkbox__label--swatch');
      label.title = input.dataset.label;
    });
  });
}

applySwatches();

const observer = new MutationObserver(() => applySwatches());
observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof HTMLElement) applySwatches(event.target);
});
